import { useContext } from "react";
import { useQuery } from "react-query";
import { apiAxios } from "services/HttpServices";
import { LoginStateContext } from "context/Login/LoginState";

async function fetchAllDatelineTemplate(_, props) {
  let url;
  if (props) {
    const { keyword, datelineTemplateId } = props;
    if (keyword) {
      url = `/jobs/dateline-template?filter[title][like]=${keyword}`;
    } else if (datelineTemplateId) {
      url = `/jobs/dateline-template/${datelineTemplateId}`;
    }
  } else {
    url = "/jobs/dateline-template";
  }
  try {
    const res = await apiAxios.get(url);
    return res.data?.data;
  } catch (e) {
    console.log(e);
  }
}

function useJobDatelineTemplateData(props) {
  const { user: userState } = useContext(LoginStateContext);
  if (props) {
    return useQuery(["dateline-template", props], fetchAllDatelineTemplate, {
      enabled: userState.isLoggedIn,
    });
  } else {
    return useQuery(["dateline-template"], fetchAllDatelineTemplate, {
      enabled: userState.isLoggedIn,
    });
  }
}

export default useJobDatelineTemplateData;
